import React from 'react';
import { EllipsisTooltip } from '@components/common';
import styled from 'styled-components';

const Header = styled(EllipsisTooltip)`
  font-size: 16px;
`;

function ColumnHeader({ metric }) {
  const text = `${metric.short} ${metric.subscript || ''}`;
  return <Header tooltipText={text}>{text}</Header>;
}

export default ColumnHeader;
